import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class GenericModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open || false
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (props.open !== undefined && props.open !== state.open) {
      return { open: props.open };
    }
    return null;
  }

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
    if (this.props.clearState) this.props.clearState();
  };

  render() {
    const { modalProps } = this.props;
    return (
      <Modal {...modalProps} isOpen={this.state.open} toggle={this.props.onToggle || this.toggle} className={this.props.className}>
        <ModalHeader toggle={this.props.onToggle || this.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>{this.props.children}</ModalBody>
        {this.props.onSubmit && this.props.formatMessage && (
          <ModalFooter>
            <Button color="primary" onClick={this.props.onSubmit}>
              {this.props.formatMessage({ id: "Submit" })}
            </Button>
          </ModalFooter>
        )}
      </Modal>
    );
  }
}

export default GenericModal;
